import {
  confirmDialog,
  notifyDialog,
  checkboxDialog,
} from '@/composables/useConfirmDialog'
import i18n from '@/plugins/i18n.js'

export const createSwal = async ({
  icon = '',
  title = '',
  confirmColor = '#2196F3',
  cancelColor = '#f53535',
  text = '',
  html = '',
  closeable = true,
  confirmButtonText = i18n.global.t('generics.ok'),
  cancelButtonText = i18n.global.t('generics.cancel'),
  isRtl = false,
  direction = '',
  showCancelButton = true,
}) => {
  if (!direction && isRtl) direction = 'rtl'

  return await confirmDialog({
    icon,
    title,
    text,
    html,
    confirmColor,
    cancelColor,
    confirmButtonText,
    cancelButtonText,
    showCancelButton,
    closeable,
    direction,
  })
}

export const timeoutSwal = ({
  icon = 'success',
  title = '',
  text = '',
  lang = 'he',
  timer = 1500,
}) => {
  let direction = lang === 'en' ? 'ltr' : 'rtl'
  if (icon === 'error' && !title) {
    title = 'Error'
  }

  return notifyDialog({
    icon,
    title,
    text,
    timer,
    direction,
  })
}

export const createCheckbox = async ({
  text = '',
  html = '',
  title = '',
  icon = 'warning',
  inputPlaceholder = '',
  confirmButtonText = 'OK',
}) =>
  checkboxDialog({
    icon,
    title,
    text,
    html,
    inputPlaceholder,
    confirmButtonText,
  })
